<template>
    <div>
        <post-recent/>
    </div>
</template>
<script>
import PostRecent from '@/components/posts/PostRecent';
export default {
    components: {
        PostRecent,
    },
}
</script>
<style lang="scss" scoped>
</style>
